<div *ngIf="vm.isBaseZone" class="field dimension">
  <label>DIMENSION:</label>
  <select
    class="type-dropdown"
    (change)="vm.dimensionTypeChanged($event, layoutViewModel)"
  >
    <option
      *ngFor="let measureType of vm.positionVM.measureTypes"
      [value]="measureType.id"
    >
      {{ measureType.displayName }}
    </option>
  </select>
</div>
<div class="container">
  <div class="buttons" *ngIf="vm.isBaseZone === false">
    <evrideo-x-button
      (mousedown)="layoutViewModel.deleteZone(vm)"
      [overrideStyle]="{ width: '15px' }"
    ></evrideo-x-button>
  </div>
  <h3 *ngIf="vm.isBaseZone">BASE ZONE</h3>
  <h3 *ngIf="vm.isBaseZone === false">ZONE {{ vm.index }}</h3>
  <p
    class="media-name"
    title="{{ vm.mediaName }}"
    (click)="vm.editMediaClicked(router)"
  >
    {{ vm.mediaTypeAsString }}
    {{ vm.mediaTypeAsString.length > 0 ? ": " : "" }} {{ vm.mediaName }}
  </p>
  <icn-collapsible [label]="'TIMING'">
    <div class="field" *ngIf="vm.isBaseZone === false && vm.zoneType !== ELayoutZoneType.empty">
      <label>OFFSET:</label>
      <evrideo-time-editor
        [(valueMs)]="vm.offsetFromBaseZoneMs"
        [fontSize]="'16px'"
        [height]="'23px'"
        [minMs]="0"
        [fullMode]="true"
        [frameRate]="25"
        [type]="'MS'"
      ></evrideo-time-editor>
    </div>
    <div class="field" *ngIf="vm.zoneType !== ELayoutZoneType.empty">
      <label>KEEP SHOW DURATION</label>
      <input type="checkbox" [(ngModel)]="vm.keepShowDuration" />
    </div>
    <div
      class="field"
      *ngIf="vm.zoneType !== ELayoutZoneType.empty && vm.keepShowDuration === false"
    >
      <label>DURATION:</label>
      <evrideo-time-editor
        [(valueMs)]="vm.durationMs"
        [fontSize]="'16px'"
        [height]="'23px'"
        [minMs]="0"
        [fullMode]="true"
        [frameRate]="25"
        [type]="'MS'"
      ></evrideo-time-editor>
    </div>
    <div class="field" *ngIf="vm.zoneType === 0">
      <label>SOM:</label>
      <evrideo-time-editor
        [(valueMs)]="vm.somMs"
        [fontSize]="'16px'"
        [height]="'23px'"
        [minMs]="0"
        [fullMode]="true"
        [frameRate]="25"
        [type]="'MS'"
      ></evrideo-time-editor>
    </div>
  </icn-collapsible>

  <icn-collapsible [label]="'SIZE & POSITION'" *ngIf="vm.isBaseZone === false">
    <div class="field" *ngIf="vm.isBaseZone === false">
      <evrideo-graphics-rectangle-f
        [vm]="vm.positionVM"
      ></evrideo-graphics-rectangle-f>
    </div>
    <div class="field" *ngIf="vm.isBaseZone === false">
      <evrideo-layer-input
        [(zIndex)]="vm.zLayer"
        [showTooltip]="false"
        [shortLabel]="''"
        [minNumber]="1"
        [maxNumber]="100"
      ></evrideo-layer-input>
    </div>
  </icn-collapsible>
  <icn-collapsible [label]="'VOLUME'" *ngIf="$any(vm.zoneType) !== ELayoutZoneType.gfx">
    <div class="field" *ngIf="$any(vm.zoneType) !== ELayoutZoneType.gfx">
      <evrideo-layer-input
        [(zIndex)]="vm.volume"
        [showTooltip]="false"
        [label]="'VOLUME'"
        [shortLabel]="''"
      ></evrideo-layer-input>
    </div>
  </icn-collapsible>

  <icn-collapsible [label]="'CROP SETTINGS'">
    <div class="field">
      <evrideo-crop-settings-editor
        [cropSettings]="vm.cropSettings"
        [title]="''"
      ></evrideo-crop-settings-editor>
    </div>
  </icn-collapsible>
</div>
